import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmendmentLauncher } from '@app/features/amendments/amendment-launcher.service';
import { ContractService } from '@app/features/contracts/contract-service';
import { DocumentViewer } from '@app/features/documents/document-viewer/document-viewer';
import { SocialSecurityDocumentAndNumberDialog } from '@app/features/documents/social-security-document-and-number-dialog/social-security-document-and-number-dialog';
import { LayoutService } from '@app/nav/layout/layout.service';
import { switchMap } from 'rxjs';
import { EmbaucheDialog } from '../../embauche-dialog/embauche-dialog';

@Component({
  selector: 'app-contract-layout',
  imports: [CommonModule, DocumentViewer, EmbaucheDialog, SocialSecurityDocumentAndNumberDialog],
  templateUrl: './contract-layout.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contract-layout.scss',
})
export class ContractLayout implements OnInit {
  readonly contractService = inject(ContractService);
  readonly layoutService = inject(LayoutService);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly amendmentLauncher = inject(AmendmentLauncher);

  contractId: string | null = null;

  ngOnInit(): void {
    this.contractId = this.route.snapshot.paramMap.get('contractId');
    if (this.contractId) {
      this.contractService.findOne(this.contractId).subscribe((contract) => {
        this.layoutService.setContract(contract);
      });
      const amendmentId = this.route.snapshot.paramMap.get('amendmentId');
      if (amendmentId) {
        this.openAmendment(this.contractId, amendmentId);
      }
    }
  }

  /**
   * L'adresse d'un avenant ouvre l'avenant par-dessus la fiche de son contrat ; le fermer ramène
   * à la fiche (RG-avenant-consultation).
   */
  private openAmendment(contractId: string, amendmentId: string): void {
    this.amendmentLauncher
      .consult(contractId, amendmentId)
      .pipe(switchMap((dialogRef) => dialogRef.afterClosed()))
      .subscribe(() => this.router.navigate(['/contrats', contractId]));
  }

  onContractSaved() {
    this.layoutService.setContract(undefined);
    this.whenRoutedThenRedirectToDashboard();
  }

  onCancelContractEdit() {
    this.layoutService.setContract(undefined);
    this.layoutService.previewDocument(null);
    this.whenRoutedThenRedirectToDashboard();
  }

  whenRoutedThenRedirectToDashboard() {
    if (this.contractId) {
      this.router.navigate(['/contrats']);
    }
  }
}
